export class TopMenuLink {
    public Id: number;
    public OrderIndex: number;
    public Href: string;
    public Text: string;
    public OpenInNewWindow: boolean;
}
export class TopMenuSpan {
    public Id: number;
    public OrderIndex: number;
    public SpanText: string;
    public IconCssClass: string;
    public IconText: string;
}
export class TopMenu {
    public Id: number;
    public DivCssClass: string;
    public Divisions: TopMenuDivision[];
}
export class TopMenuDivision {
    public Id: number;
    public OrderIndex: number;
    public DivCssClass: string;
    public UlCssClass: string;
    public levelOneList: LevelOne[];
}
export class LevelOne {
    public Id: number;
    public OrderIndex: number;
    public LiCssClass: string;
    public isMenuNotLink: boolean;
    public Link: TopMenuLink;
    public Span: TopMenuSpan;
    public levelTwoList: LevelTwo[];
}
export class LevelTwo {
    public Id: number;
    public ParentId: number;
    public Span: TopMenuSpan;
    public UlCssClass: string;
    public isMenuNotLink: boolean;
    public Link: TopMenuLink;
    public levelThreeList: LevelThree[];
    public LiCssClass: string;
}
export class LevelThree {
    public Id: number;
    public ParentId: number;
    public UlCssClass: string;
    public LiCssClass: string;
    public Link: TopMenuLink;
    public Span: TopMenuSpan;
}

export class MenuMap {
    public Id: number;
    public Title: string;
}